import React, { useState } from "react";
import { InputCSVStyled } from "./InputCSVStyled";
import { parseCSV } from "./parseCSV";
var InputCSV = function (_a) {
    var label = _a.label, onCSVRead = _a.onCSVRead, onError = _a.onError;
    var _b = useState(""), filename = _b[0], setFilename = _b[1];
    var _c = useState(""), error = _c[0], setError = _c[1];
    var onChange = function (ev) {
        setError("");
        var target = ev.currentTarget;
        var file = target.files ? target.files[0] : null;
        if (file) {
            setFilename(file.name);
            var reader = new FileReader();
            reader.readAsText(file, "UTF-8");
            reader.onload = function (ev) {
                var csvData = ev.target.result;
                var parsedCSVData = parseCSV(csvData, ",");
                onCSVRead(file.name, parsedCSVData);
            };
            reader.onerror = function (ev) {
                setError("There was an error loading the file");
                var target = ev.currentTarget;
                var file = target.files ? target.files[0] : null;
                if (file) {
                    onError
                        ? onError(file.name)
                        : console.error("Error loading " + file.name);
                }
                else {
                    onError
                        ? onError("Unknown filename")
                        : console.error("Error loading csv file.");
                }
            };
        }
    };
    return (React.createElement(InputCSVStyled, null,
        React.createElement("label", { htmlFor: "csvUpload" }, label !== null && label !== void 0 ? label : "Select CSV File"),
        React.createElement("input", { id: "csvUpload", type: "file", accept: ".csv", onChange: onChange }),
        filename !== "" ? React.createElement("span", { className: "filename" }, filename) : React.createElement(React.Fragment, null),
        error !== "" ? React.createElement("span", { className: "error" }) : React.createElement(React.Fragment, null)));
};
export default InputCSV;
//# sourceMappingURL=InputCSV.js.map